import React, { useState, useRef, useEffect } from "react";
import "./Ecosystem.css";
import ntrading from "../Assets/ip-gif.gif";


// Import AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function Ecosystem() {
  const scrollContainerRef = useRef(null);

  const [isDisabled, setDisabled] = useState(true);

  const handleScroll = () => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      const scrollTop = scrollContainer.scrollTop;
      const translateY = -scrollTop / 2;
      scrollContainer.style.transform = `translateY(${translateY}px)`;
    }
  };

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 2000,  // Duration for animation
      easing: 'ease-out', // Easing function
      once: true, // Ensure the animation happens once when the element comes into view
    });

    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
      return () => {
        scrollContainer.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  return (
    <div className="scroll-container ease-out" ref={scrollContainerRef}>
      <div className="main_ecosysytem" id="ecosystem">
        <div className="container" style={{ marginTop: "70px" }} id="AboutUs">
          <div
            className="row align-items-center justify-content-center"
            data-aos="fade-up-right"  // Add AOS animation here
            data-aos-duration="3000"
          >
            <div className="col-md-5 order-mobile-first">
              <img className="pc-image" src={ntrading} alt="" />
            </div>
            <div className="col-md-5 order-mobile-second">
              <h6
                className="main-new-cursive ss HeadingFont "
                style={{  marginTop: "10px" }}
                data-aos="fade-left"  // Add AOS animation here
                data-aos-duration="2000"
              >
               Building a Strong Future with IP Token
              </h6>

              <div className="right_eco_content">
                <p className="text-white ss" data-aos="fade-up" data-aos-duration="2500">
                The token comes equipped with anti-bot and anti-whale mechanisms to ensure fair trading and a healthy market. One of the standout features is its staking mechanism, which strengthens the community and promotes long-term growth. By participating in staking, you contribute to the network's stability and enjoy a reliable stream of passive rewards. As the ecosystem grows, staking will bridge the gap between active participation and financial success, fostering a stronger, more engaged community.
                </p>
                <div style={{ marginTop: "20px" }} data-aos="zoom-in" data-aos-duration="2000">
                  <a href="https://t.me/ippp2025" target="_blank">
                    <button className="button-5">Join Telegram </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
